<template>
  <div>
    <multi-list-select 
      v-if="!loading && customerCnpj" 
      :list="selects" 
      :selected-items="items" 
      option-value="id" 
      option-text="name" 
      :isDisabled="disabled"
      placeholder="Selecione carteiras" 
      @select="onSelect">
    </multi-list-select>
    <div v-else-if="loading" class="form-control" style="background-color: #f8f9fa; color: #6c757d;">
      Carregando Carteiras do Contrato...
    </div>
    <div v-else class="form-control" style="background-color: #f8f9fa; color: #6c757d;">
      Carregando Carteiras...
    </div>
  </div>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';
import MultiListSelect from 'vue-search-select/src/lib/MultiListSelect';

export default {
  name: 'SelectCompaniesMultiple',
  components: { MultiListSelect },
  data() {
    return {
      selects: [],
      items: [],
      lastSelectItem: {},
      loading: false,
    };
  },
  props: {
    disabled: {
      type: Boolean,
    },
    customerCnpj: {
      type: String,
      default: null,
    },
    contractId: {
      type: [String, Number],
      default: null,
    },
  },
  methods: {
    getData() {
      if (!this.customerCnpj) {
        console.warn('CNPJ do cliente é necessário para buscar as carteiras');
        return;
      }

      this.loading = true;

      const url = `${baseApiUrl}/v1/company/search/?cnpj=${this.customerCnpj}&amount=100&status=active&sortType=ref_id&sortOrder=ASC`;
      axios(url).then((res) => {
        const companies = [];
        if (res.data.data && res.data.data.length > 0) {
          res.data.data.forEach(company => {
            if (company.products && company.products.length > 0) {
              company.products.forEach(product => {
                if (product.pivot && product.pivot.ref_id) {
                  companies.push({
                    id: product.pivot.ref_id,
                    name: `${product.pivot.ref_id} - ${company.name}`,
                    company_id: product.pivot.company_id,
                    product_id: product.pivot.product_id,
                    company_name: company.name,
                  });
                }
              });
            }
          });
        }

        this.selects = companies;
        this.loadContractCompanies();
      }).catch((error) => {
        console.error('Erro ao buscar carteiras:', error);
        this.selects = [];
        this.loading = false;
      });
    },
    async loadContractCompanies() {
      if (!this.contractId || this.contractId === 'add') {
        this.loading = false;
        return;
      }

      try {
        const url = `${baseApiUrl}/v1/customer/contract/companies/${this.contractId}`;
        const response = await axios.get(url);

        let contractRefIds = [];
        contractRefIds = response.data.data;

        if (contractRefIds && contractRefIds.length > 0) {
          const selectedItems = this.selects.filter(item =>
            contractRefIds.includes(item.id)
          );

          this.items = selectedItems;

          this.$emit(
            'selected',
            selectedItems.map((item) => item.id)
          );
        }
      } catch (error) {
        console.error('Erro ao carregar carteiras do contrato:', error);
      } finally {
        this.loading = false;
      }
    },
    onSelect(items, lastSelectItem) {
      this.items = items;
      this.$emit(
        'selected',
        items.map((item) => item.id)
      );
    },
  },
  created() {
    this.getData();
  },
  watch: {
    customerCnpj() {
      this.getData();
    },
    contractId() {
      if (this.selects.length > 0) {
        this.loadContractCompanies();
      }
    },
  },
};
</script>
